import { render } from "./MonthRange.vue?vue&type=template&id=ff504b96"
import script from "./MonthRange.vue?vue&type=script&lang=js"
export * from "./MonthRange.vue?vue&type=script&lang=js"

import "./MonthRange.vue?vue&type=style&index=0&id=ff504b96&lang=css"
script.render = render

export default script